import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';

import { fetchFlashDealsSection } from 'Redux/ducks/algolia-calls';
import env from 'Env';
import ProductCarousel from 'Components/HomePage/ProductCarousel';
import CountdownTimer from 'Components/Utility/CountdownTimer';
import imgixConfig from 'Config/imgix';

import 'Components/FlashSales/FlashDealsSection.scss';

export default function FlashDealsSection() {
  const [hits, setHits] = useState([]);

  useEffect(() => {
    const doFetch = async () => {
      const newHits = await fetchFlashDealsSection();
      setHits(newHits);
    };

    doFetch();
  }, []);

  const liveSales = useSelector(state => state.sales.liveSales);
  let sale = {};
  if (!isEmpty(liveSales)) sale = liveSales.find(s => s.flashDeals);

  const dealLaunchDates = get(sale, 'dealLaunchDates', []);
  const saleEndTime = get(sale, 'endDate', '');
  const bgImg = get(sale, 'sectionBackground', '');
  const saleName = get(sale, 'saleName', '');
  const displayName = get(sale, 'displayName', '');
  const saleDescription = get(sale, 'description', '');

  if (!sale || isEmpty(dealLaunchDates)) return false;
  if (Date.now() > Date.parse(saleEndTime)) return false;

  const firstLaunchTime = dealLaunchDates.sort()[0];
  const lastLaunchTime = dealLaunchDates.sort()[dealLaunchDates.length - 1];

  let nextDealTime = '';
  cloneDeep(dealLaunchDates.sort()).reverse().forEach((time) => {
    if (Date.now() < Date.parse(time)) {
      nextDealTime = time;
    }
  });

  const bgImgSrc = `${env.cdnUrl}/product/original/${bgImg}`;

  const firstlaunch = Date.now() < Date.parse(firstLaunchTime);
  const postlaunch = Date.now() > Date.parse(lastLaunchTime);

  let cardsToShow = 3;
  if (hits.length === 2) cardsToShow = 2;
  if (hits.length === 4) cardsToShow = 4;

  if (isEmpty(hits)) return false;

  return (
    <section className="container FlashDealsSection">
      <div className="FlashDealsSection__headingBanner">
        <div className="FlashDealsSection__headingBanner__content">
          <div className="FlashDealsSection__headingBanner__content__headings">
            <h2 className="FlashDealsSection__headingBanner__content__headings__heading">
              <FormattedMessage
                id="flashdeals.title"
                defaultMessage="{saleName} Flash Deals"
                values={{
                  saleName: displayName,
                }}
              />
            </h2>
            {saleDescription &&
              <div className="FlashDealsSection__headingBanner__content__headings__strapline">
                {saleDescription}
              </div>
            }
          </div>

          <div className="FlashDealsSection__headingBanner__content__timer">
            <div className="FlashDealsSection__headingBanner__content__timer__text">
              {!firstlaunch && !postlaunch &&
                <FormattedMessage id="flashdeals-countdown.launches-in" defaultMessage="Next deal live in" />
              }
              {postlaunch &&
                <FormattedMessage id="flashdeals-countdown.all-deals-live" defaultMessage="All deals now live" />
              }
            </div>
            {!postlaunch &&
              <div className="FlashDealsSection__headingBanner__content__timer__countdown">
                <CountdownTimer showZero value={Date.parse(nextDealTime)} />
              </div>
            }
          </div>
        </div>
        <div className="FlashDealsSection__headingBanner__background">
          <img
            srcSet={`
              ${bgImgSrc}?${imgixConfig}&w=2248&h=200&fit=crop,
              ${bgImgSrc}?${imgixConfig}&w=1686&h=150&fit=crop,
              ${bgImgSrc}?${imgixConfig}&w=1124&h=100&fit=crop,
              ${bgImgSrc}?${imgixConfig}&w=562&h=50&fit=crop
            `}
            src={`${bgImgSrc}?${imgixConfig}&w=2248&h=200&fit=crop`}
            alt={saleName}
          />
        </div>
      </div>

      {!isEmpty(hits) &&
        <ProductCarousel
          newCarousel
          leftAlign
          showFlashDealBar
          hitData={hits}
          slidesToShow={cardsToShow}
        />
      }
    </section>
  );
}
